import { render, staticRenderFns } from "./base-dropdown.vue?vue&type=template&id=412468c6"
import script from "./base-dropdown.vue?vue&type=script&lang=js"
export * from "./base-dropdown.vue?vue&type=script&lang=js"
import style0 from "./base-dropdown.vue?vue&type=style&index=0&id=412468c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports